import { getOfflineQueueTelemetrySnapshot } from "@seims/shared";
import { getOfflineDataSyncMetrics } from "@seims/shared/src/services/db";

const DEFAULT_INDEXED_DB_SNAPSHOT = {
  pendingCount: 0,
  estimatedSizeBytes: 0,
  bySyncState: {},
  lastUpdated: null,
};

let indexedDbSnapshot = { ...DEFAULT_INDEXED_DB_SNAPSHOT };
let started = false;

const refreshIndexedDbSnapshot = async () => {
  const metrics = await getOfflineDataSyncMetrics();
  indexedDbSnapshot = {
    ...DEFAULT_INDEXED_DB_SNAPSHOT,
    ...metrics,
  };
};

export const startOfflineSyncStatsTracking = () => {
  if (typeof window === "undefined" || started) {
    return;
  }

  started = true;

  const refreshSafely = () => {
    refreshIndexedDbSnapshot().catch(() => {
      // Ignore refresh errors and preserve latest known snapshot.
    });
  };

  refreshSafely();

  const onOnline = () => refreshSafely();
  const onVisibility = () => {
    if (!document.hidden) {
      refreshSafely();
    }
  };

  window.addEventListener("online", onOnline);
  window.addEventListener("pwa-sync-update", refreshSafely);
  window.addEventListener("shared:offline-queue-registry", refreshSafely);
  document.addEventListener("visibilitychange", onVisibility);

  window.setInterval(refreshSafely, 30000);
};

export const getMergedOfflineSyncStats = () => {
  const queueSnapshot = getOfflineQueueTelemetrySnapshot();

  return {
    queue: queueSnapshot,
    indexedDb: indexedDbSnapshot,
    pendingCount: Number(queueSnapshot.pendingCount || 0) + Number(indexedDbSnapshot.pendingCount || 0),
    estimatedSizeBytes:
      Number(queueSnapshot.estimatedSizeBytes || 0) + Number(indexedDbSnapshot.estimatedSizeBytes || 0),
    sources: {
      queueEstimatedSizeBytes: Number(queueSnapshot.estimatedSizeBytes || 0),
      indexedDbEstimatedSizeBytes: Number(indexedDbSnapshot.estimatedSizeBytes || 0),
    },
  };
};
